import React from 'react'
import MediaPreview from './MediaPreview'
import ContentSection from './ContentSection'

/**
 * 개별 타임라인 아이템 컴포넌트
 */
function TimelineItem({
  section,
  index,
  editingSection,
  setEditingSection,
  isGeneratingTTS,
  isConvertingMp4,
  isUploadingMedia,
  selectedVoice,
  subtitleSettings,
  titleSettings,
  videoSettings,
  onTextUpdate,
  onFileUpload,
  onFileDrop,
  onRemove,
  onRemoveMedia,
  onGenerateTTS,
  onAudioUpload
}) {
  const handleDragOver = (e) => {
    e.preventDefault()
  }

  return (
    <div className="timeline-item">
      <div className="timeline-number">
        {index}
      </div>
      
      <MediaPreview
        section={section}
        isConvertingMp4={isConvertingMp4}
        isUploadingMedia={isUploadingMedia}
        onFileUpload={onFileUpload}
        onFileDrop={onFileDrop}
        onRemove={onRemove}
        onRemoveMedia={onRemoveMedia}
        onAudioUpload={onAudioUpload}
        handleDragOver={handleDragOver}
        subtitleSettings={subtitleSettings}
        titleSettings={titleSettings}
        videoSettings={videoSettings}
      />
      
      <ContentSection
        section={section}
        editingSection={editingSection}
        setEditingSection={setEditingSection}
        isGeneratingTTS={isGeneratingTTS}
        onTextUpdate={onTextUpdate}
        onGenerateTTS={onGenerateTTS}
        onAudioUpload={onAudioUpload}
      />
    </div>
  )
}

export default TimelineItem